const translationKeys = {
  accounts_transactions_pay_from_account:
    'accounts_transactions_pay_from_account',
  accounts_fill_account_button_text: 'accounts_fill_account_button_text',
  accounts_account_information: 'accounts_account_information',
  accounts_associated_cards_title: 'accounts_associated_cards_title',
  accounts_account_details_title: 'accounts_account_details_title',
  accounts_account_details_start_date: 'accounts_account_details_start_date',
  accounts_account_details_account_name:
    'accounts_account_details_account_name',
  accounts_account_details_iban: 'accounts_account_details_iban',
  accounts_account_details_iban_label: 'accounts_account_details_iban_label',
  accounts_account_details_iban_description:
    'accounts_account_details_iban_description',
  accounts_account_details_bic_swift: 'accounts_account_details_bic_swift',
  accounts_account_details_bic_swift_label:
    'accounts_account_details_bic_swift_label',
  accounts_account_details_bic_swift_description:
    'accounts_account_details_bic_swift_description',
  accounts_account_details_roles_title: 'accounts_account_details_roles_title',
  accounts_account_details_cards_title: 'accounts_account_details_cards_title',
  accounts_account_details_deposits_title:
    'accounts_account_details_deposits_title',
  accounts_account_details_withdrawals_title:
    'accounts_account_details_withdrawals_title',
  accounts_account_number_label: 'accounts_account_number_label',
  accounts_card_details_block_card_label:
    'accounts_card_details_block_card_label',
  accounts_card_details_unblock_card_label:
    'accounts_card_details_unblock_card_label',
  accounts_card_details_blocking_info_description:
    'accounts_card_details_blocking_info_description',
  accounts_card_details_account_name_label:
    'accounts_card_details_account_name_label',
  accounts_card_details_card_holder_label:
    'accounts_card_details_card_holder_label',
  accounts_card_details_card_type_label:
    'accounts_card_details_card_type_label',
  accounts_account_details_deposits_interest_rate:
    'accounts_account_details_deposits_interest_rate',
  accounts_account_details_deposits_interest_this_year:
    'accounts_account_details_deposits_interest_this_year',
  accounts_account_details_deposits_interest_last_year:
    'accounts_account_details_deposits_interest_last_year',
  accounts_account_details_withdrawals_restricted_withdrawal_amount:
    'accounts_account_details_withdrawals_restricted_withdrawal_amount',
  accounts_account_details_withdrawals_interest_rate:
    'accounts_account_details_withdrawals_interest_rate',
  accounts_account_details_withdrawals_overdraft_interest_rate:
    'accounts_account_details_withdrawals_overdraft_interest_rate',
  accounts_account_details_withdrawals_interest_this_year:
    'accounts_account_details_withdrawals_interest_this_year',
  accounts_account_details_withdrawals_interest_last_year:
    'accounts_account_details_withdrawals_interest_last_year',
  accounts_account_details_withdrawals_fees_this_year:
    'accounts_account_details_withdrawals_fees_this_year',
  accounts_transaction_details_title: 'accounts_transaction_details_title',
  accounts_transaction_details_amount: 'accounts_transaction_details_amount',
  accounts_transaction_details_from: 'accounts_transaction_details_from',
  accounts_transaction_details_kid: 'accounts_transaction_details_kid',
  accounts_transaction_details_message: 'accounts_transaction_details_message',
  accounts_transaction_details_description:
    'accounts_transaction_details_description',
  accounts_transaction_details_booked: 'accounts_transaction_details_booked',
  accounts_associated_cards_error: 'accounts_associated_cards_error',
  accounts_account_balance_error: 'accounts_account_balance_error',
  accounts_transaction_list_error: 'accounts_transaction_list_error',
  accounts_account_details_available_balance:
    'accounts_account_details_available_balance',
  accounts_account_details_booked_balance:
    'accounts_account_details_booked_balance',
  accounts_account_details_credit_balance:
    'accounts_account_details_credit_balance',
  accounts_account_details_balance_title:
    'accounts_account_details_balance_title',
  accounts_account_details_disponents_assistant_guardian:
    'accounts_account_details_disponents_assistant_guardian',
  accounts_account_details_disponents_co_borrower:
    'accounts_account_details_disponents_co_borrower',
  accounts_account_details_disponents_guarantor:
    'accounts_account_details_disponents_guarantor',
  accounts_account_details_disponents_guardian:
    'accounts_account_details_disponents_guardian',
  accounts_account_details_disponents_landlord:
    'accounts_account_details_disponents_landlord',
  accounts_account_details_disponents_owner:
    'accounts_account_details_disponents_owner',
  accounts_account_details_disponents_third_party_receiver:
    'accounts_account_details_disponents_third_party_receiver',
  accounts_account_details_disponents_third_party_user:
    'accounts_account_details_disponents_third_party_user',
  accounts_transaction_status_reserved: 'accounts_transaction_status_reserved',
  accounts_list_header_title: 'accounts_list_header_title',
  accounts_list_header_available_balance:
    'accounts_list_header_available_balance',
  accounts_list_header_customer_program:
    'accounts_list_header_customer_program',
  accounts_list_header_open_account_button:
    'accounts_list_header_open_account_button',
  accounts_list_header_accounts_reorder:
    'accounts_list_header_accounts_reorder',
  accounts_list_balance_error: 'accounts_list_balance_error',
  accounts_open_account_overview_header_title:
    'accounts_open_account_overview_header_title',
  accounts_open_account_overview_header_description:
    'accounts_open_account_overview_header_description',
  accounts_open_account_overview_header_customer_program:
    'accounts_open_account_overview_header_customer_program',
  accounts_customer_loyalty_program_intr:
    'accounts_customer_loyalty_program_intr',
  accounts_customer_loyalty_program_lean:
    'accounts_customer_loyalty_program_lean',
  accounts_customer_loyalty_program_lese:
    'accounts_customer_loyalty_program_lese',
  accounts_customer_loyalty_program_lest:
    'accounts_customer_loyalty_program_lest',
  accounts_customer_loyalty_program_leun:
    'accounts_customer_loyalty_program_leun',
  accounts_customer_loyalty_program_leve:
    'accounts_customer_loyalty_program_leve',
  accounts_customer_loyalty_program_prba:
    'accounts_customer_loyalty_program_prba',
  accounts_customer_loyalty_program_saga:
    'accounts_customer_loyalty_program_saga',
  accounts_customer_loyalty_program_sapl:
    'accounts_customer_loyalty_program_sapl',
  accounts_customer_loyalty_program_topl:
    'accounts_customer_loyalty_program_topl',
  accounts_customer_loyalty_program_tost:
    'accounts_customer_loyalty_program_tost',
  accounts_customer_loyalty_program_tota:
    'accounts_customer_loyalty_program_tota',
  accounts_account_details_header_breadcrumb_homepage:
    'accounts_account_details_header_breadcrumb_homepage',
  accounts_account_details_header_breadcrumb_my_accounts:
    'accounts_account_details_header_breadcrumb_my_accounts',
  accounts_reorder_header_title: 'accounts_reorder_header_title',
  accounts_reorder_header_description: 'accounts_reorder_header_description',
  accounts_reorder_my_accounts: 'accounts_reorder_my_accounts',
  accounts_reorder_save_button: 'accounts_reorder_save_button',
  accounts_reorder_divider_text: 'accounts_reorder_divider_text',
  accounts_breadcrumb_accounts_label: 'accounts_breadcrumb_accounts_label',
  accounts_list_header_tabs_all_accounts:
    'accounts_list_header_tabs_all_accounts',
  accounts_list_header_tabs_my_accounts:
    'accounts_list_header_tabs_my_accounts',
  accounts_list_header_tabs_other_accounts:
    'accounts_list_header_tabs_other_accounts',
  accounts_breadcrumb_open_account_label:
    'accounts_breadcrumb_open_account_label',
  accounts_account_header_available_balance_text:
    'accounts_account_header_available_balance_text',
  accounts_account_header_reserved_amount_text:
    'accounts_account_header_reserved_amount_text',
  accounts_account_header_more_options_button_text:
    'accounts_account_header_more_options_button_text',
  accounts_account_transaction_list_load_more_transactions_button_text:
    'accounts_account_transaction_list_load_more_transactions_button_text',
  accounts_account_fetch_account_error_title:
    'accounts_account_fetch_account_error_title',
  accounts_account_fetch_account_error_message:
    'accounts_account_fetch_account_error_message',
  accounts_account_fetch_transactions_error_message:
    'accounts_account_fetch_transactions_error_message',
  accounts_account_fetch_transactions_error_title:
    'accounts_account_fetch_transactions_error_title',
  accounts_account_transactions_list_empty:
    'accounts_account_transactions_list_empty',
  accounts_account_more_info_button_text:
    'accounts_account_more_info_button_text',
  accounts_account_details_header_title:
    'accounts_account_details_header_title',
  accounts_account_details_type_label: 'accounts_account_details_type_label',
  accounts_account_transaction_cell_reserved_text:
    'accounts_account_transaction_cell_reserved_text',
  accounts_account_transaction_details_sender:
    'accounts_account_transaction_details_sender',
  accounts_account_transaction_details_account_number:
    'accounts_account_transaction_details_account_number',
  accounts_account_transaction_details_amount:
    'accounts_account_transaction_details_amount',
  accounts_account_transaction_details_message:
    'accounts_account_transaction_details_message',
  accounts_account_transaction_details_date:
    'accounts_account_transaction_details_date',
  accounts_account_transaction_details_to_text:
    'accounts_account_transaction_details_to_text',
  accounts_account_transaction_details_type_text:
    'accounts_account_transaction_details_type_text',
  accounts_account_transaction_details_booked:
    'accounts_account_transaction_details_booked',
  accounts_account_transaction_details_id:
    'accounts_account_transaction_details_id',
  accounts_account_transaction_details_receiver:
    'accounts_account_transaction_details_receiver',
  accounts_account_transaction_details_from:
    'accounts_account_transaction_details_from',
  accounts_account_transaction_details_type_morsom_sparing:
    'accounts_account_transaction_details_type_morsom_sparing',
  accounts_account_transaction_details_type_debit_card:
    'accounts_account_transaction_details_type_debit_card',
  accounts_account_transaction_details_type_visa_card:
    'accounts_account_transaction_details_type_visa_card',
  accounts_account_transaction_details_type_credit_card:
    'accounts_account_transaction_details_type_credit_card',
  accounts_account_transaction_details_type_atm:
    'accounts_account_transaction_details_type_atm',
  accounts_account_transaction_details_type_self_service:
    'accounts_account_transaction_details_type_self_service',
  accounts_account_transaction_details_type_loan:
    'accounts_account_transaction_details_type_loan',
  accounts_account_transaction_details_type_salary:
    'accounts_account_transaction_details_type_salary',
  accounts_account_transaction_details_type_pension:
    'accounts_account_transaction_details_type_pension',
  accounts_account_transaction_details_type_internationial:
    'accounts_account_transaction_details_type_internationial',
  accounts_account_transaction_details_type_outgoing:
    'accounts_account_transaction_details_type_outgoing',
  accounts_account_transaction_details_type_einvoice:
    'accounts_account_transaction_details_type_einvoice',
  accounts_account_transaction_details_type_transfer:
    'accounts_account_transaction_details_type_transfer',
  accounts_account_transaction_details_type_vipps_out:
    'accounts_account_transaction_details_type_vipps_out',
  accounts_account_transaction_details_header_title:
    'accounts_account_transaction_details_header_title',
  accounts_fetch_transaction_details_error_title:
    'accounts_fetch_transaction_details_error_title',
  accounts_fetch_transaction_details_error_subtitle:
    'accounts_fetch_transaction_details_error_subtitle',
  accounts_account_transactions_loading_text:
    'accounts_account_transactions_loading_text',
  accounts_account_details_balance_error_message:
    'accounts_account_details_balance_error_message',
  accounts_transaction_details_account_info_error_message:
    'accounts_transaction_details_account_info_error_message',
  accounts_account_fetch_roles_error_title:
    'accounts_account_fetch_roles_error_title',
  accounts_account_fetch_roles_error_message:
    'accounts_account_fetch_roles_error_message',
  accounts_account_roles_info_button_text:
    'accounts_account_roles_info_button_text',
  accounts_account_pay_button_text: 'accounts_account_pay_button_text',
  accounts_account_transfer_button_text:
    'accounts_account_transfer_button_text',
  accounts_account_payment_overview_button_text:
    'accounts_account_payment_overview_button_text',
  accounts_account_close_account_button_text:
    'accounts_account_close_account_button_text',
  accounts_account_faq_section_title: 'accounts_account_faq_section_title',
  accounts_account_faq_when_is_money_available_in_account_title:
    'accounts_account_faq_when_is_money_available_in_account_title',
  accounts_account_faq_when_is_money_available_in_account_message:
    'accounts_account_faq_when_is_money_available_in_account_message',
  accounts_account_faq_transfer_time_from_other_bank_title:
    'accounts_account_faq_transfer_time_from_other_bank_title',
  accounts_account_faq_transfer_time_from_other_bank_message:
    'accounts_account_faq_transfer_time_from_other_bank_message',
  accounts_account_faq_booked_and_available_amount_message:
    'accounts_account_faq_booked_and_available_amount_message',
  accounts_account_faq_booked_and_available_amount_title:
    'accounts_account_faq_booked_and_available_amount_title',
  accounts_account_faq_change_account_name_title:
    'accounts_account_faq_change_account_name_title',
  accounts_account_faq_change_account_name_message:
    'accounts_account_faq_change_account_name_message',
  accounts_account_faq_add_authorised_users_title:
    'accounts_account_faq_add_authorised_users_title',
  accounts_account_faq_add_authorised_users_message:
    'accounts_account_faq_add_authorised_users_message',
  accounts_account_faq_priced_services_message:
    'accounts_account_faq_priced_services_message',
  accounts_account_faq_priced_services_title:
    'accounts_account_faq_priced_services_title',
  accounts_account_faq_reserved_amount_without_details_title:
    'accounts_account_faq_reserved_amount_without_details_title',
  accounts_account_faq_reserved_amount_without_details_message:
    'accounts_account_faq_reserved_amount_without_details_message',
  accounts_account_faq_unknown_reservations_on_card_message:
    'accounts_account_faq_unknown_reservations_on_card_message',
  accounts_account_faq_unknown_reservations_on_card_title:
    'accounts_account_faq_unknown_reservations_on_card_title',
  accounts_account_faq_delete_reservation_message:
    'accounts_account_faq_delete_reservation_message',
  accounts_account_faq_delete_reservation_title:
    'accounts_account_faq_delete_reservation_title',
  accounts_account_faq_money_from_unknown_sender_title:
    'accounts_account_faq_money_from_unknown_sender_title',
  accounts_account_faq_money_from_unknown_sender_message:
    'accounts_account_faq_money_from_unknown_sender_message',
  accounts_account_faq_registered_payment_title:
    'accounts_account_faq_registered_payment_title',
  accounts_account_faq_registered_payment_message:
    'accounts_account_faq_registered_payment_message',
  accounts_account_faq_transaction_receipt_message:
    'accounts_account_faq_transaction_receipt_message',
  accounts_account_faq_transaction_receipt_title:
    'accounts_account_faq_transaction_receipt_title',
  accounts_account_faq_transfer_between_accounts_title:
    'accounts_account_faq_transfer_between_accounts_title',
  accounts_account_faq_transfer_between_accounts_message:
    'accounts_account_faq_transfer_between_accounts_message',
  accounts_account_faq_transfer_time_between_banks_immediate_payment_title:
    'accounts_account_faq_transfer_time_between_banks_immediate_payment_title',
  accounts_account_faq_transfer_time_between_banks_immediate_payment_message:
    'accounts_account_faq_transfer_time_between_banks_immediate_payment_message',
  accounts_account_time_stamp_text: 'accounts_account_time_stamp_text',
  accounts_account_transactions_load_next_page_error:
    'accounts_account_transactions_load_next_page_error',
  accounts_account_list_error_title: 'accounts_account_list_error_title',
  accounts_account_list_error_subtitle: 'accounts_account_list_error_subtitle',
  accounts_account_print_button_text: 'accounts_account_print_button_text',
  accounts_account_textfile_account_number_label:
    'accounts_account_textfile_account_number_label',
  accounts_account_textfile_account_name_label:
    'accounts_account_textfile_account_name_label',
  accounts_account_textfile_account_owner_label:
    'accounts_account_textfile_account_owner_label',
  accounts_account_textfile_available_balance_label:
    'accounts_account_textfile_available_balance_label',
  accounts_account_textfile_booked_balance_label:
    'accounts_account_textfile_booked_balance_label',
  accounts_list_print_button_text: 'accounts_list_print_button_text',
  accounts_list_more_options_button_text:
    'accounts_list_more_options_button_text',
  accounts_download_as_textfile_button_text:
    'accounts_download_as_textfile_button_text',
  accounts_account_export_to_excel_button_text:
    'accounts_account_export_to_excel_button_text',
  accounts_account_transactions_textfile_date_label:
    'accounts_account_transactions_textfile_date_label',
  accounts_account_transactions_textfile_description_label:
    'accounts_account_transactions_textfile_description_label',
  accounts_account_transactions_textfile_amount_in_label:
    'accounts_account_transactions_textfile_amount_in_label',
  accounts_account_transactions_textfile_amount_out_label:
    'accounts_account_transactions_textfile_amount_out_label',
  accounts_account_transaction_details_type_vipps_in:
    'accounts_account_transaction_details_type_vipps_in',
  accounts_account_transaction_details_type_business_payment:
    'accounts_account_transaction_details_type_business_payment',
  accounts_account_transaction_details_type_incoming:
    'accounts_account_transaction_details_type_incoming',
  accounts_account_transactions_textfile_booking_date_label:
    'accounts_account_transactions_textfile_booking_date_label',
  accounts_transaction_details_reserved_amount_info_title:
    'accounts_transaction_details_reserved_amount_info_title',
  accounts_transaction_details_reserved_amount_info_subtitle:
    'accounts_transaction_details_reserved_amount_info_subtitle',
  accounts_list_info_transactions_are_moved_title:
    'accounts_list_info_transactions_are_moved_title',
  accounts_list_info_transactions_are_moved_subtitle:
    'accounts_list_info_transactions_are_moved_subtitle',
  accounts_list_empty_text: 'accounts_list_empty_text',
};

Object.freeze(translationKeys);

export default translationKeys;
